<div class="content-container">
  <ng-container *ngIf="isLoadingSubject$ | async; then loader; else fields"></ng-container>
</div>

<ng-template #loader>
  <mode-loader
    class="loader"
    [class.visible]="showLoader$ | async"
    type="secondaryGreen"
    >
  </mode-loader>
</ng-template>

<ng-template #fields>
  <div class="menu-label">Period</div>
  <mode-labeled-menu
    menuClass="relative-date-period-menu"
    [selected]="selectedPeriod"
    [menuItems]="periodOptions"
    (menuChange)="onChangePeriod($event)"
  ></mode-labeled-menu>
  <div class="divider"></div>
  <div class="rel-from">
    <div class="menu-label">From</div>
    <mode-relative-date-fromto
      unsetLabel="No set start date"
      [fixedDefault]="dataMinTimestamp"
      [fromto]="filter?.from"
      (fromtoChange)="onChangeFrom($event)"
    ></mode-relative-date-fromto>
  </div>
  <div class="rel-to">
    <div class="menu-label">To</div>
    <mode-relative-date-fromto
      unsetLabel="No set end date"
      [fixedDefault]="dataMaxTimestamp"
      [fromto]="filter?.to"
      (fromtoChange)="onChangeTo($event)"
    ></mode-relative-date-fromto>
  </div>
  <div class="fixed-desc" [class.visible]="isFixedRange">
    For open-ended ranges, choose "No set start/end date" from the dropdown.
  </div>
  <div class="starts">
    <mode-labeled-menu
      menuClass="relative-date-starts-menu"
      label="Start of week"
      *ngIf="showWeekStarts"
      [selected]="selectedWeekStart"
      [menuItems]="weekStartOptions"
      (menuChange)="onChangeWeekStart($event)"
    ></mode-labeled-menu>
    <mode-labeled-menu
      menuClass="relative-date-starts-menu"
      label="Start of year"
      *ngIf="showYearStarts"
      [selected]="selectedYearStart"
      [menuItems]="yearStartOptions"
      (menuChange)="onChangeYearStart($event)"
    ></mode-labeled-menu>
    <div *ngIf="!(showWeekStarts && showYearStarts)"></div>
  </div>
  <div class="filter-desc" [class.invalid]="!isValid">
    <capra-icon icon="icon-warning" *ngIf="!isValid"></capra-icon>
    <div [innerHTML]="filterDescription"></div>
  </div>
</ng-template>
